export var SEO_TYPE_MAIN_BLOCK = 'https://schema.org/FAQPage';
export var SEO_TYPE_QUESTION = 'https://schema.org/Question';
export var SEO_TYPE_ANSWER = 'https://schema.org/Answer';